module.exports = __webpack_public_path__ + "img/asia.c309f48b.jpeg";